module.exports = __webpack_public_path__ + "img/skull_intelligence.718cc9fb.png";